import { apiV2 } from '../lib/baseAxios';

export interface TemplateHistoryEvent {
  id: string;
  templateId: string;
  templateTitle: string;
  fileId: string;
  templateOutput?: string;
  usedAt: string;
  createdAt: string;
}

const templateHistoryUrl = '/template-history';

// Note: Template usage is automatically tracked via PostProcessedText when templates are saved
// No need for explicit tracking - the existing saveTemplateOutput handles this

export const getUserTemplateHistory = async (
  page: number = 1,
  limit: number = 50
) => {
  try {
    const response = await apiV2.get<{
      success: boolean;
      data: {
        templateHistory: TemplateHistoryEvent[];
        pagination: {
          page: number;
          limit: number;
          totalItems: number;
          totalPages: number;
          hasNextPage: boolean;
          hasPrevPage: boolean;
        };
      };
      message?: string;
    }>(templateHistoryUrl, {
      params: { page, limit },
    });
    return response.data;
  } catch (error: any) {
    // If endpoint doesn't exist (404), return empty history instead of error
    if (error?.response?.status === 404) {
      console.warn(
        'Template history endpoint not yet available, returning empty history'
      );
      return {
        success: true,
        data: {
          templateHistory: [],
          pagination: {
            page: 1,
            limit: 50,
            totalItems: 0,
            totalPages: 0,
            hasNextPage: false,
            hasPrevPage: false,
          },
        },
      };
    }

    console.error('Failed to fetch template history:', error);
    return {
      success: false,
      message: 'Failed to load template history',
    };
  }
};
